import { render, staticRenderFns } from "./LoginDBP.form.vue?vue&type=template&id=74474596&scoped=true&lang=pug&"
import script from "./LoginDBP.form.vue?vue&type=script&lang=ts&"
export * from "./LoginDBP.form.vue?vue&type=script&lang=ts&"
import style0 from "./LoginDBP.form.vue?vue&type=style&index=0&id=74474596&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74474596",
  null
  
)

export default component.exports